import {AbMenu} from "../../widgets/menu/menu.widget.js";
import {AbButton} from "../../widgets/button/button.widget.js";
import {i18n} from "../../domain/i18n.js";
import {BaseComponent} from "../../base.component.js";

/**
 * @typedef {_BaseComponentProps} _AbBadgeMenu_Props
 * @property {string} imgSrc
 * @property {'internal'|'external'} [placement = 'external']
 * @property {function(ref: ComponentChild)} onRef
 * @property {any} customButtons
 * @property {number} popupOffsetRight
 */

export class AbBadgeMenu extends BaseComponent {

  /** @type {AbMenu} */
  _menu;

  /**
   * @param {_AbBrandImage_Props} props
   */
  constructor(props) {
    super(props);
    this.state = { };
  }

  minimize() {
    if (this._menu) {
      this._menu.minimize();
    }
  }

  /**
   * @param {_AbBadgeMenu_Props} props
   * @param {object} state
   * @param {_AbComponent_Context} ctx
   * @returns {ComponentChild}
   */
  render = (props, state, ctx) => {
    return (
      <div className="ab-badge-menu">
        <AbMenu onRef={menu => this._menu = menu} placement={props.placement} customButtons={props.customButtons} popupOffsetRight={props.popupOffsetRight}>
          <AbButton type="link" caption={i18n.menu.checkAuthorizations.caption} href={ctx.composition.input.certificateUrl} />
          <AbButton type="link" caption={i18n.menu.imprint.caption} href={i18n.menu.imprint.link} />
          <AbButton type="link" caption={i18n.menu.privacyPolicy.caption} href={i18n.menu.privacyPolicy.link} />
        </AbMenu>
      </div>

    );
  };

}
